// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__xBYk6","iconWithCounter":"styles_iconWithCounter__BTzoN","counterForLabel":"styles_counterForLabel__jVpuA","counterForIcon":"styles_counterForIcon___zha0"};